import {useEffect, useRef, useState} from 'react'
/**
 * Tracks intersection of a DOM node with the viewport (or a given root) via IntersectionObserver.
 */
const useInView = ({threshold = 0, root = null, rootMargin = '0px'} = {}) => {
    const targetRef = useRef(null)
    const [entry, setEntry] = useState(null)

    useEffect(() => {
        const node = targetRef.current
        if (!node || typeof IntersectionObserver === 'undefined') return undefined

        const observer = new IntersectionObserver(([observedEntry]) => setEntry(observedEntry), {
            threshold,
            root,
            rootMargin,
        })

        observer.observe(node)

        return () => observer.disconnect()
    }, [threshold, root, rootMargin])

    return [targetRef, entry]
}

export default useInView
